class DefaultSnackbarOptions {
    id;
    color = 'info';
    top = true;
    text = '';
    timeout = 2000;
    constructor(id) {
        this.id = id;
    }
}
const SnackBarModule = {
    namespaced: true,
    state: {
        id: 0,
        snackbars: []
    },
    getters: {},
    mutations: {
        open(state, snackbar) {
            state.snackbars.push({ ...new DefaultSnackbarOptions(state.id++), ...snackbar });
        },
        close(state, snackbar) {
            state.snackbars = state.snackbars.filter(item => item.id !== snackbar.id);
        }
    },
    actions: {}
};
export default SnackBarModule;
